import React from 'react'

interface PaymentOptionsViewProps {
  onClose: () => void
  primaryColor?: string
}

export function PaymentOptionsView({ onClose, primaryColor = '#3b82f6' }: PaymentOptionsViewProps) {
  const paymentMethods = [
    { id: 'card', name: 'Credit/Debit Card', icon: '💳', description: 'Visa, Mastercard, Verve' },
    { id: 'mobile', name: 'Mobile Money', icon: '📱', description: 'MTN, Vodafone, AirtelTigo' },
    { id: 'bank', name: 'Bank Transfer', icon: '🏦', description: 'Direct bank transfer' },
    { id: 'paystack', name: 'Paystack', icon: '💰', description: 'Secure online payment' }
  ]

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h4 style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>Payment Methods</h4>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px'
          }}
        >
          <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div style={{ display: 'grid', gap: '12px' }}>
        {paymentMethods.map((method) => (
          <div
            key={method.id}
            style={{
              padding: '16px',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = primaryColor
              e.currentTarget.style.backgroundColor = `${primaryColor}10`
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#e5e7eb'
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            <div style={{ fontSize: '24px' }}>{method.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>{method.name}</div>
              <div style={{ fontSize: '14px', color: '#6b7280' }}>{method.description}</div>
            </div>
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        ))}
      </div>

      <div style={{ 
        marginTop: '16px', 
        padding: '12px', 
        backgroundColor: '#f3f4f6', 
        borderRadius: '8px',
        fontSize: '14px',
        color: '#6b7280'
      }}>
        💡 All payments are secured with 256-bit SSL encryption
      </div>
    </div>
  )
}